import { render, staticRenderFns } from "./ArticleSerialsDialog.vue?vue&type=template&id=40b5915e&scoped=true&"
import script from "./ArticleSerialsDialog.vue?vue&type=script&lang=js&"
export * from "./ArticleSerialsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSerialsDialog.vue?vue&type=style&index=0&id=40b5915e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b5915e",
  null
  
)

export default component.exports